export const UNASSIGNED_OPTION_VALUE = "unassigned";
export const UNASSIGNED_OPTION_LABEL = "Unassigned";
export const ASSIGNED_TO_CLIENT_OPTION_VALUE = "assignedToClient";
export const ASSIGNED_TO_CLIENT_OPTION_LABEL = "Assigned to client";
